var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rightpanel-vacancies"},[(_vm.vacancies.length)?_c('div',{staticClass:"info-vac__content"},_vm._l((_vm.vacancies),function(item,i){return _c('Vacancy',{key:i,attrs:{"item":item}})}),1):_c('Alert',{staticClass:"empty",attrs:{"text":_vm.errorText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }